module.exports = __webpack_public_path__ + "static/media/eyeBlinkRight.5fb55f2e.obj";